import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserPosts } from '../../../../pages/auth/utils/firebase/userOperations';

export const fetchUserPosts = createAsyncThunk(
  'profile/fetchUserPosts',
  async (userId, { rejectWithValue }) => {
    try {
      return await getUserPosts(userId);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
